export const theme = {
  primaryColors: {
    orange: "hsl(26, 100% ,55%)",
    paleOrange: "hsl(25, 100%, 94%)",
  },
  neutralColors: {
    veryDarkBlue: "hsl(220, 13%, 13%)",
    darkGrayishBlue: "hsl(219, 9%, 45%)",
    grayishBlue: "hsl(220, 14%, 75%)",
    lightGrayishBlue: "hsl(223, 64%, 98%)",
    white: "hsl(0, 0%, 100%)",
    black: " hsl(0, 0%, 0%)",
    darkGray: "#655b54bf",
  },

  breakpoints: {
    mobile: "320px",
    medium: "450px",
    large: "768px",
    desktop: "1040px",
  },
};
